import { useEffect, useCallback } from 'react';

import { SplashScreen } from 'src/components/loading-screen';
import { useRouter, useSearchParams } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';

import { useAuthStore } from '../auth.store';

type Props = {
  children: React.ReactNode;
};

export default function GuestGuard({ children }: Props) {
  const { isLoading } = useAuthStore();

  return <>{isLoading ? <SplashScreen /> : <Container>{children}</Container>}</>;
}

function Container({ children }: Props) {
  const router = useRouter();

  const searchParams = useSearchParams();

  const returnTo = searchParams.get('returnTo') || paths.root;

  const { isAuthenticated } = useAuthStore();

  const check = useCallback(() => {
    if (isAuthenticated) {
      router.replace(returnTo);
    }
  }, [isAuthenticated, returnTo, router]);

  useEffect(() => {
    check();
  }, [check]);

  return <>{children}</>;
}
